// Acts like a .resx file

export const ERROR_MESSAGES = {
  CONTAINER_NOT_EMPTY: "Failed to delete item because it contains child items.",
  DUPLICATE_EMAIL: "This email is already registered.",
  GENERIC_ERROR: "An unexpected error occurred. Please try again later.",
  INVALID_CREDENTIALS: "Invalid password or email.",
  NETWORK_ERROR: "Please check your network connection and try again.",
  OUTDATED_CLIENT: "Your client is outdated. Please refresh and try again.",
  RESOURCE_NOT_FOUND: "Unable to find the specified resource.",
  UNIQUE_CODE_FAILED: "This code is already in use. Please enter another value.",
  OWNERSHIP_TRANSFER_FAILED: "Failed to transfer ownership. Please try again.",
  PROJECT_SHARING_FAILED: "Failed to update sharing setting. Please try again.",
  TASK_ASSIGNMENT_NO_CHANGES: "No Task Assignment changes to save.",
  PDF_DOWNLOAD_FAILED: "Failed to download PDF. Please try again.",
  SNAPSHOT_GENERATION_FAILED: "Failed to generate snapshot. Please try again.",
  SNAPSHOT_LIST_FAILED: "Failed to load snapshots. Please try again.",
  CREATE_FAILED: "Failed to create item. Please try again.",
  DELETE_FAILED: "Failed to delete item. Please try again.",
  INVALID_INPUT: "Please enter a valid input.",
  GREATER_THAN_ZERO_REQUIRED: "Please ensure input values are greater than 0. ",
  DELETE_FAILED_RISK_QUANTS_STILL_LINKED: "Risk quantifications are still linked to this item. Please Delete.",
  SIMULATION_ALREADY_RUNNING: "User already has a simulation running."
};

export const SUCCESS_MESSAGES = {
  ITEM_CREATED: "Item created successfully!",
  ITEM_DELETED: "Item deleted successfully!",
  ITEM_REMOVED: "Item removed successfully!",
  BATCH_UPDATED: "Changes saved!",
  TAG_ADDED: "Tag added!",
  TAG_REMOVED: "Tag removed!",
  DND_MOVED: "Item moved successfully!",
  ITEM_UPDATED: "Item updated successfully!",
  OWNERSHIP_TRANSFERRED: "Project ownership transferred successfully!",
  PROJECT_SHARED: "Sharing settings updated successfully!",
  LOGIN_SUCCESS: "Login successful!",
  REGISTRATION_SUCCESS: "Registration successful!",
  TASK_ASSIGNMENT_SAVEED: "Task assignments saved successfully!",
  PDF_DOWNLOADED: "PDF downloaded successfully!",
  SNAPSHOT_GENERATED: "Snapshot generated successfully!",
  SNAPSHOT_LIST_LOADED: "Snapshots loaded successfully!",
  VERIFICATION_SUCCESS: "Email verified!"
};

export const LOADING_MESSAGES = {
  CREATE: "Creating...",
  DELETE: "Deleting...",
  SIM_RUNNING: "Running...",
  BATCH_UPDATE: "Saving all changes...",
  ADD_TAG: "Adding tag...",
  REMOVE_TAG: "Removing tag...",
  DND_MOVE: "Moving item...",
  TRANSFERRING_OWNERSHIP: "Transferring...",
  SINGLE_SAVE: "Saving...",
  LOGGING_IN: "Logging in...",
  REGISTER: "Registering...",
  DOWNLOADING_PDF: "Downloading PDF...",
  SNAPSHOT_GENERATION: "Generating snapshot...",
  SNAPSHOT_LIST: "Loading snapshots...",
};

export const SERVER_RESPONSE = {
  CONTAINER_NOT_EMPTY: "Container contains child items.",
  DUPLICATE_EMAIL: "User with this email already exists.",
  NETWORK_ERROR: "Failed to fetch",
  OUTDATED_CLIENT: "The model being saved is outdated.",
  RESOURCE_NOT_FOUND: "Unable to find the specified resource.",
  UNIQUE_CODE_FAILED: "Code already exists.",
  RISK_QUANTIFCATIONS_STILL_LINKED: "Risk quantifications are still linked to this item. Please Delete.",
};
